import { datadogRum } from '@datadog/browser-rum';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// import { mockServiceWorker } from 'src/test/worker';
import { AvatarBuilderPage, HomePage } from 'src/pages';
import {
  fetchAmpConfig,
  saveApiGatewayUrl,
} from 'src/services/amp-config.service';
import AuthService from 'src/services/api/auth.service';
import { getDdRumConfig } from 'src/services/dd-rum.service';
import { store } from 'src/store';

import './styles/index.scss';

async function initApp() {
  try {
    await fetchAmpConfig();
    saveApiGatewayUrl();
    await AuthService.init();
    datadogRum.init(getDdRumConfig());

    const keycloak = AuthService.getKC();
    const isAuthenticated = keycloak.authenticated;

    if (!isAuthenticated) return;

    // to enable mocking, just uncomment this line
    // await mockServiceWorker();

    const container = document.getElementById('root');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(container!);

    root.render(
      <StrictMode>
        <Provider store={store}>
          <Router basename={import.meta.env.VITE_APP_ROUTER_BASENAME}>
            <Routes>
              <Route path="/home/student">
                <Route index element={<HomePage />} />
                <Route path="avatar-builder" element={<AvatarBuilderPage />} />
              </Route>
            </Routes>
          </Router>
        </Provider>
      </StrictMode>,
    );
  } catch (e) {
    window.location.assign(`${window.location.origin}/home/student/50x.html`);
  }
}

initApp();
